module.exports = __webpack_public_path__ + "media/images/feature-4-bd8ec07c.png";